var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header_right w-100 d-none justify-content-around d-md-flex"},[_c('HeaderButtons',{staticClass:"w-100 d-md-flex"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }